'use client';

import { useState } from 'react';
import { recordProductEvent } from '@/lib/product-analytics';

const reasons = [
  ['missing_information', 'Missing information'], ['outdated_information', 'Information looks outdated'],
  ['hard_to_use', 'Hard to use'], ['price_or_signup', 'Price or signup requirement'],
  ['just_exploring', 'Just exploring'], ['other', 'Something else'],
] as const;

export function ResultFeedback({ feature, outcome, surface = 'site' }: {
  feature: 'tracking' | 'schedules' | 'pricing'; outcome: string; surface?: 'site' | 'widget';
}) {
  const [answer, setAnswer] = useState<'yes' | 'no' | null>(null);
  const [done, setDone] = useState(false);
  const context = { page_area: feature, outcome, surface };
  const options = feature === 'pricing' ? [
    ['price_too_high', 'Price is too high'], ['missing_carrier', 'My carrier is missing'],
    ['unclear_value', 'I need to see more value'], ['missing_feature', 'A feature is missing'],
    ['not_ready', 'Not ready to buy'], ['other', 'Something else'],
  ] as const : reasons;
  const buttonStyle = { border: '1px solid #aaa', borderRadius: 4, padding: '6px 12px', background: '#fff', color: '#222', cursor: 'pointer' };
  return <section aria-label="Result feedback" style={{ margin: '20px 0', padding: 16, border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }}>
    {done ? <p role="status" style={{ margin: 0 }}>Thanks for the feedback.</p> : <>
      <p style={{ margin: '0 0 10px' }}>{answer === 'no' ? 'What could be better?' : feature === 'pricing' ? 'Do these plans fit what you need?' : 'Did this result help with your task?'}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {answer === null ? (['yes', 'no'] as const).map(value => <button key={value} type="button" style={buttonStyle} onClick={() => {
          recordProductEvent('result_feedback', { ...context, helpful: value });
          setAnswer(value); if (value === 'yes') setDone(true);
        }}>{value === 'yes' ? 'Yes' : 'Not yet'}</button>) : options.map(([value, label]) => <button key={value} type="button" style={buttonStyle} onClick={() => {
          recordProductEvent('result_feedback_reason', { ...context, feedback_reason: value }); setDone(true);
        }}>{label}</button>)}
      </div>
      <p style={{ margin: '10px 0 0', fontSize: 12, color: '#666' }}>Optional feedback to help us improve Shipzy.</p>
    </>}
  </section>;
}
